<template>
  <transition name="msgbox-fade">
    <div class="msgbox-wrapper" :class="customClass" v-show="visible">
      <div class="msgbox">
        <span
          class="close-icon"
          v-show="showClose"
          @click="handleAction('cancel')"
        ></span>
        <div
          class="msgbox-content"
          v-if="typeof content === 'string'"
          v-html="content"
        ></div>
        <slot></slot>
        <div class="msgbox-btns">
          <span
            class="msgbox-btn default"
            v-if="$type === '$confirm'"
            @click="handleAction('cancel')"
            >{{ cancelButtonText }}</span
          >
          <span class="msgbox-btn primary" @click="handleAction('confirm')">{{
            confirmButtonText
          }}</span>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      visible: false
    }
  },
  props: {
    content: {
      required: true,
      validator(val) {
        if (typeof val === 'string') {
          return true
        }
        // 是否是vnode
        if (typeof val === 'object' && Reflect.has(val, 'tag')) {
          return true
        }
      }
    },
    beforeClose: {
      type: Function,
      required: false,
      default: null
    },
    confirmButtonText: {
      type: String,
      required: false,
      default: 'confirm'
    },
    cancelButtonText: {
      type: String,
      required: false,
      default: 'cancel'
    },
    $type: {
      validator(val) {
        return ['$alert', '$confirm'].indexOf(val) !== -1
      },
      required: false,
      default: '$confirm'
    },
    customClass: {
      type: Array,
      default() {
        return []
      },
      required: false
    },
    showClose: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  mounted() {
    if (Reflect.has(this.content, 'tag')) {
      this.$slots.default = this.content
    }
  },
  methods: {
    async handleAction(action) {
      if (typeof this.beforeClose === 'function') {
        await this.beforeClose(action)
      }
      this.doclose()
      this.$emit('closeDialog', action)
    },
    doopen() {
      this.visible = true
    },
    doclose() {
      this.visible = false
    }
  }
}
</script>
<style lang="less" scoped>
.msgbox-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  .msgbox {
    width: 540px;
    border-radius: 28px;
    overflow: hidden;
    background: #ffffff;
    .msgbox-content {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 34px;
      line-height: 44px;
      min-height: 192px;
    }
    .msgbox-btns {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 44px;
      font-size: 34px;
      height: 87px;
      border-top: rgba(60, 60, 67, 0.29) solid 1px;
      .msgbox-btn {
        border-right: rgba(51, 51, 51, 0.15) solid 1px;
        text-align: center;
        flex: 1;
        height: 100%;
        line-height: 87px;
        &:last-child {
          border-right-width: 0px;
        }
        &.default {
          color: rgba(51, 51, 51, 0.7);
        }
        &.primary {
          color: #fc6b18;
        }
      }
    }
  }
}
.msgbox-fade-enter-active {
  transition: all 2s cubic-bezier(0, 2.3, 0.8, 1);
}
.msgbox-fade-leave-active {
  transition: all 0.8s ease;
}
.msgbox-fade-enter,
.msgbox-fade-leave-to {
  opacity: 0;
}
</style>
